import axios from 'axios'

export function getFreightForRegion(regionId) {
    return (dispatch, getState) => {
        const orderTotal = getState().cart.totalWithoutFreight
        const email = getState().personalInfo.email
        dispatch({ type: 'GET_FREIGHT' })
        return axios
            .get(`${process.env.CORE_API}/freight/${regionId}`, {
                params: {
                    orderTotal: orderTotal,
                    email: email,
                },
            })
            .then((response) => {
                dispatch({ type: 'GET_FREIGHT_SUCCESS', payload: response.data })
            })
            .catch((err) => {
                console.error(err)
                dispatch({ type: 'GET_FREIGHT_FAILED', payload: err })
            })
    }
}

export function getFreightForOrder() {
    return (dispatch, getState) => {
        const regionId = getState().region.id
        const orderTotal = getState().cart.totalWithoutFreight
        const email = getState().personalInfo.email
        dispatch({ type: 'GET_FREIGHT_FOR_ORDER' })
        return axios
            .get(`${process.env.CORE_API}/freight/${regionId}`, {
                params: {
                    orderTotal: orderTotal,
                    email: email,
                },
            })
            .then((response) => {
                dispatch({
                    type: 'GET_FREIGHT_FOR_ORDER_SUCCESS',
                    payload: response.data,
                })
            })
            .catch((err) => {
                console.error(err)
                dispatch({ type: 'GET_FREIGHT_FOR_ORDER_FAILED', payload: err })
            })
    }
}
